import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, LightbulbIcon, MessageCircleIcon, CalendarCheckIcon } from 'lucide-react';
export function ProductBreakdown() {
  const features = [{
    icon: <BookOpenIcon className="w-6 h-6 text-white" data-id="element-151" />,
    title: 'Fundamentos Claros',
    text: 'Fundamentos claros para entender qué significa Competir Sin Miedo y qué dice la evidencia.',
    color: 'bg-brand-green',
    image: 'https://cdn.magicpatterns.com/uploads/q2u4NzRayfkrVXAmvamSpe/WhatsApp_Image_2026-04-01_at_19.27.44.jpg'
  }, {
    icon: <LightbulbIcon className="w-6 h-6 text-white" data-id="element-152" />,
    title: 'Herramientas Mentales',
    text: 'Herramientas mentales clave: respiración, concentración, autodiálogo, visualización y confianza.',
    color: 'bg-brand-amber',
    image: 'https://cdn.magicpatterns.com/uploads/we9c1HzxVzpkzmYp3FBPTN/WhatsApp_Image_2026-04-01_at_19.27.45.jpg'
  }, {
    icon: <MessageCircleIcon className="w-6 h-6 text-white" data-id="element-153" />,
    title: 'Estrategias Familiares',
    text: 'Estrategias para la familia: cómo apoyar sin invadir, comunicar mejor y ordenar el entorno.',
    color: 'bg-brand-slate',
    image: 'https://cdn.magicpatterns.com/uploads/hgGvU1edbtDdXRk9DFq26P/WhatsApp_Image_2026-04-01_at_19.27.45c.jpg'
  }, {
    icon: <CalendarCheckIcon className="w-6 h-6 text-white" data-id="element-154" />,
    title: 'Plan de Acción',
    text: 'Un plan práctico de 30 días, checklists y hojas de trabajo para aplicar de inmediato.',
    color: 'bg-brand-green-light',
    image: 'https://cdn.magicpatterns.com/uploads/wwpQqriz1HucYt8n3qCHMP/WhatsApp_Image_2026-04-01_at_19.27.451.jpg'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-155">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4" data-id="element-158">
            Dentro de Competir sin Miedo vas a encontrar:
          </h2>
          <div className="w-24 h-1 bg-brand-amber mx-auto rounded-full" data-id="element-159"></div>
        </motion.div>

        <div className="space-y-12" data-id="element-160">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className={`flex flex-col ${index % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8`} data-id="element-161">
              <div className="w-full md:w-1/2" data-id="element-162">
                <div className="aspect-video rounded-2xl overflow-hidden shadow-lg relative group" data-id="element-163">
                  <img src={feature.image} alt={feature.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-164" />
                  <div className={`absolute inset-0 opacity-20 ${feature.color} mix-blend-multiply`} data-id="element-165"></div>
                </div>
              </div>

              <div className="w-full md:w-1/2 space-y-4" data-id="element-166">
                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl ${feature.color} shadow-md mb-2`} data-id="element-167">
                  {feature.icon}
                </div>
                <h3 className="text-2xl font-heading text-brand-slate" data-id="element-168">
                  {feature.title}
                </h3>
                <p className="text-lg text-brand-slate-light leading-relaxed" data-id="element-169">
                  {feature.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}